module.exports = __webpack_public_path__ + "prod/1.42.2/img/xtrh_one_one.cfb6dfe7.png";